import { authAPI } from './api';

// 模拟用户数据
const mockUsers = [
  {
    email: 'test@example.com',
    password: 'password123',
    name: 'Test User',
    type: 'tenant',
  },
  {
    email: 'landlord@example.com',
    password: 'password123',
    name: 'John Smith',
    type: 'landlord',
    company: 'Smith Property Management',
  },
];

// 用户注册
export const register = async (userData) => {
  try {
    const response = await authAPI.register(userData);
    const { user, access, refresh } = response.data;
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    localStorage.setItem('user', JSON.stringify(user));
    return { success: true, user };
  } catch (error) {
    if (error.response?.data) {
      return { success: false, error: error.response.data };
    }
    return { success: false, error: 'Registration failed. Please try again.' };
  }
};

// 用户登录
export const login = async (login, password) => {
  try {
    const response = await authAPI.login({ login, password });
    const { user, access, refresh } = response.data;
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    localStorage.setItem('user', JSON.stringify(user));
    return { success: true, user };
  } catch (error) {
    if (error.response?.data) {
      return { success: false, error: error.response.data };
    }
    return { success: false, error: 'Invalid login or password' };
  }
};

// 用户登出
export const logout = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
};

// 检查是否已认证
export const isAuthenticated = () => {
  const token = localStorage.getItem('access_token');
  return !!token;
};

// 获取当前用户
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

// 检查房东邮箱
export const checkLandlordEmail = async (email) => {
  try {
    const response = await authAPI.checkLandlordEmail(email);
    return { success: true, isApproved: response.data.is_approved };
  } catch (error) {
    // 如果是503服务不可用错误，返回特殊标记
    if (error.response?.status === 503) {
      return { 
        success: false, 
        isServerError: true,
        error: error.response?.data?.error || 'Service temporarily unavailable. Please try again later.' 
      };
    }
    // 其他错误（如网络错误、500等）
    return { 
      success: false, 
      isServerError: true,
      error: error.response?.data?.error || 'Failed to check email. Please try again.' 
    };
  }
}; 